import { store } from 'src/stores';

import { onBoardingActions } from '../reducers';
import { CREATE_LETTER_STEPPER } from '../constants';

export const mountCreateLetter = () => {
  store.dispatch(onBoardingActions.changeCurrentStep(CREATE_LETTER_STEPPER[0]));
};
